(function ($) {
  // noConflict モード: ここから下では $ で jQuery を使用
  class Top {
    constructor(el,opt){
      this.el = el;
      if($("." + this.el).length > 0){
        this.event();
      }
    }
    event(){
      const $html = $('html');
      const $trigger = $('.js-menu-trigger');
      const $drawer = $('.js-menu-drawer');
  
      const closeMenu = () => {
        if (!$html.hasClass('is-menu-open')) return;
        $html.removeClass('is-menu-open');
        $trigger.attr('aria-expanded', 'false').attr('aria-label', 'メニューを開く');
        $drawer.attr('hidden', true);
        scrollBan();
      };
  
      $trigger.on('click', function() {
        const isOpen = $html.hasClass('is-menu-open');
        if (isOpen) {
          closeMenu();
          return;
        }
        $html.addClass('is-menu-open');
        $trigger.attr('aria-expanded', 'true').attr('aria-label', 'メニューを閉じる');
        $drawer.removeAttr('hidden');
        scrollBan();
      });
  
      $drawer.on('click', 'a', closeMenu);
      $drawer.on('click', '.js-menu-overlay', closeMenu);
  
      const ACCESS_KEY = 'hitohataAccessBanner';
      const $access = $('.js-accessBanner');
      const closeAccess = () => {
        if (!$access.hasClass('is-active')) return;
        $access.removeClass('is-active').attr('aria-hidden', 'true');
        try {
          localStorage.setItem(ACCESS_KEY, '1');
        } catch (e) {}
        if ($html.hasClass('is-hidden')) scrollBan();
      };
      if ($access.length) {
        let seen = false;
        try {
          seen = !!localStorage.getItem(ACCESS_KEY);
        } catch (e) {}
        if (!seen) {
          $access.addClass('is-active').attr('aria-hidden', 'false');
          scrollBan();
        }
        $access.on('click', '.js-accessBannerClose', closeAccess);
        $(document).on('keydown.accessBanner', function(e) {
          if (e.key === 'Escape') closeAccess();
        });
      }
  
      const $programTabs = $('.js-programTabs .p-top-program-tab');
      const $programPanels = $('.js-programPanel');
      $programTabs.on('click', function() {
        const $tab = $(this);
        const index = $programTabs.index($tab);
        $programTabs
          .removeClass('is-active')
          .attr({ 'aria-selected': 'false', tabindex: '-1' });
        $tab.addClass('is-active').attr({ 'aria-selected': 'true', tabindex: '0' });
        $programPanels.attr('hidden', true).eq(index).removeAttr('hidden');
      });
  
      const $planTabs = $('.js-planTabs .p-top-plan-tab');
      const $planPanels = $('.js-planPanel');
      $planTabs.on('click', function() {
        const $tab = $(this);
        const index = $planTabs.index($tab);
        $planTabs
          .removeClass('is-active')
          .attr({ 'aria-selected': 'false', tabindex: '-1' });
        $tab.addClass('is-active').attr({ 'aria-selected': 'true', tabindex: '0' });
        $planPanels.attr('hidden', true).eq(index).removeAttr('hidden');
      });
  
      if (document.querySelector('.js-voiceSwiper')) {
        const $voiceBar = $('.p-top-voice-bar');
        const updateVoiceBar = (swiper) => {
          const total = swiper.el.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)').length || 1;
          const progress = (swiper.realIndex + 1) / total;
          $voiceBar.css('--progress', progress);
        };
        const voiceListSwiper = new Swiper('.js-voiceSwiper', {
          slidesPerView: 'auto',
          spaceBetween: 10,
          centeredSlides: true,
          initialSlide: 1,
          loop: true,
          loopedSlides: 3,
          loopAdditionalSlides: 3,
          speed: 600,
          grabCursor: true,
          autoplay: {
            delay: 2800,
            disableOnInteraction: false,
          },
          on: {
            init: updateVoiceBar,
            slideChange: updateVoiceBar,
          },
        });
  
        const $voiceModal = $('.js-voiceModal');
        const $voiceModalCurrent = $('.js-voiceModalCurrent');
        let voiceModalOpen = false;
        let voiceModalSwiper = null;
  
        const updateVoiceModalPager = (swiper) => {
          $voiceModalCurrent.text(swiper.realIndex + 1);
        };
  
        if (document.querySelector('.js-voiceModalSwiper')) {
          voiceModalSwiper = new Swiper('.js-voiceModalSwiper', {
            slidesPerView: 1,
            speed: 400,
            autoHeight: false,
            observer: true,
            observeParents: true,
            touchStartPreventDefault: false,
            spaceBetween: 10,
            navigation: {
              nextEl: '.js-voiceModalNext',
              prevEl: '.js-voiceModalPrev',
            },
            on: {
              init: updateVoiceModalPager,
              slideChange: updateVoiceModalPager,
            },
          });
  
          document.querySelectorAll('.p-top-voice-modal-card').forEach((card) => {
            card.addEventListener('touchmove', (event) => {
              event.stopPropagation();
            }, { passive: true });
          });
        }
  
        const openVoiceModal = (index) => {
          if ($html.hasClass('is-menu-open')) {
            closeMenu();
          }
          if (!voiceModalOpen) {
            scrollBan();
            voiceModalOpen = true;
          }
          $voiceModal.addClass('is-active').attr('aria-hidden', 'false');
          if (voiceListSwiper.autoplay) {
            voiceListSwiper.autoplay.stop();
          }
          if (voiceModalSwiper) {
            requestAnimationFrame(() => {
              voiceModalSwiper.update();
              voiceModalSwiper.slideTo(index, 0);
            });
          }
        };
  
        const closeVoiceModal = () => {
          if (!voiceModalOpen) return;
          $voiceModal.removeClass('is-active').attr('aria-hidden', 'true');
          scrollBan();
          voiceModalOpen = false;
          if (voiceListSwiper.autoplay) {
            voiceListSwiper.autoplay.start();
          }
        };
  
        $(document).on('click', '.js-voiceModalOpen', function(e) {
          e.preventDefault();
          const index = Number($(this).attr('data-index')) || 0;
          openVoiceModal(index);
        });
  
        $voiceModal.on('click', '.js-voiceModalClose', function() {
          closeVoiceModal();
        });
  
        $(document).on('keydown', function(e) {
          if (e.key === 'Escape') {
            closeVoiceModal();
          }
        });
      }
  
      if (document.querySelector('.js-supportSwiper')) {
        const $supportBar = $('.p-top-support-bar');
        const updateSupportBar = (swiper) => {
          const total = swiper.el.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)').length || 1;
          const progress = (swiper.realIndex + 1) / total;
          $supportBar.css('--progress', progress);
        };
        new Swiper('.js-supportSwiper', {
          slidesPerView: 'auto',
          spaceBetween: 15,
          centeredSlides: true,
          initialSlide: 1,
          loop: true,
          loopedSlides: 3,
          loopAdditionalSlides: 3,
          speed: 600,
          grabCursor: true,
          autoplay: {
            delay: 2800,
            disableOnInteraction: false,
          },
          on: {
            init: updateSupportBar,
            slideChange: updateSupportBar,
          },
        });
      }
  
      if (document.querySelector('.js-scroll')) {
        new ScrollHint('.js-scroll', {
          i18n: {
            scrollable: '横スクロール',
          },
          suggestiveShadow: true,
        });
      }
  
      const $planFeeModal = $('.js-planFeeModal');
      const $planFeePanels = $('.js-planFeePanel');
      const closePlanFee = () => {
        if (!$planFeeModal.hasClass('is-active')) return;
        $planFeeModal.removeClass('is-active').attr('aria-hidden', 'true');
        if ($html.hasClass('is-hidden')) scrollBan();
      };
      $('.js-planFeeOpen').on('click', function() {
        const plan = $(this).data('plan');
        $planFeePanels.attr('hidden', true).filter('[data-plan="' + plan + '"]').removeAttr('hidden');
        $planFeeModal.addClass('is-active').attr('aria-hidden', 'false');
        if (!$html.hasClass('is-hidden')) scrollBan();
        requestAnimationFrame(function() {
          window.dispatchEvent(new Event('resize'));
        });
      });
      $planFeeModal.on('click', '.js-planFeeClose', closePlanFee);
      $(document).on('keydown.planFee', function(e) {
        if (e.key === 'Escape') closePlanFee();
      });
  
      if (document.querySelector('.js-checkSwiper')) {
        new Swiper('.js-checkSwiper', {
          slidesPerView: 'auto',
          spaceBetween: 20,
          centeredSlides: true,
          loop: true,
          loopedSlides: 8,
          loopAdditionalSlides: 3,
          speed: 600,
          grabCursor: true,
          autoplay: {
            delay: 2800,
            disableOnInteraction: false,
          },
        });
      }
  
      const $messageAcc = $('.js-messageAcc');
      if ($messageAcc.length) {
        $messageAcc.on('click', '.js-messageAccBtn', function() {
          const $wrap = $(this).closest('.js-messageAcc');
          const open = !$wrap.hasClass('is-active');
          $wrap.toggleClass('is-active', open);
          $(this).attr('aria-expanded', open ? 'true' : 'false');
          $(this).find('.p-top-message-acc-ttl').text(open ? '閉じる' : '続きを読む');
        });
      }
  
      $(document).on('click', 'a[href="#cashback-terms"]', function() {
        const $btn = $('#cashback-terms .js-accordion');
        if ($btn.length && !$btn.hasClass('is-active')) {
          $btn.trigger('click');
        }
      });
  
      const flags = document.querySelectorAll('.p-top-fv-illust .js-fv-flag');
      if (flags.length && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        const rand = (min, max) => min + Math.random() * (max - min);
        flags.forEach((flag) => {
          const play = () => {
            flag.classList.remove('is-hide');
            flag.classList.add('is-show');
            setTimeout(() => {
              flag.classList.remove('is-show');
              flag.classList.add('is-hide');
              setTimeout(play, rand(700, 2600));
            }, rand(1600, 2800));
          };
          setTimeout(play, rand(200, 1600));
        });
      }
    }
  }
  
  class Accordion {
    constructor(el,opt){
      this.el = el;
      if($("." + this.el).length > 0){
        this.event();
      }
    }
    event(){
      $('.' + this.el).click(function() {
         $(this).next().slideToggle(Number($('html').data('transition')));
         $(this).toggleClass('is-active');
      })
    }
  }
    // 参考サイト
  // https://hacknote.jp/archives/15289/
  
  let cookie = {
  	/**
  	 * 取得
  	 * @param {string} cookieName 取得するCookieの名前
  	 */
  	get : function(cookieName) {
  		if (!navigator.cookieEnabled) return false;
  
  		var getCookieAllData  = document.cookie,
  		    getCookieAllDatas = getCookieAllData.split(';'),
  		    getCookieDatas    = {},
  		    cookieKeyValue    = [],
  		    cookieKey         = '',
  		    cookieValue       = '';
  
  		var hashLength = function(arr) {
  			var result = 0, key = false;
  
  			if (typeof arr !== 'object') return false;
  
  			for (key in arr) result++;
  
  			return result;
  		};
  
  		for (var i = 0, len = getCookieAllDatas.length; i < len; i++) {
  			if (getCookieAllDatas[i] && getCookieAllDatas[i] !== '') {
  				cookieKeyValue = getCookieAllDatas[i].split('=');
  				cookieKey      = cookieKeyValue[0].replace(/^\s+/, '');
  				cookieValue    = '';
  
  				if (cookieKeyValue[1]) {
  					cookieValue = decodeURIComponent(cookieKeyValue[1]);
  				}
  
  				getCookieDatas[cookieKey] = cookieValue;
  			}
  		}
  
  		if (hashLength(getCookieDatas) > 0) {
  			if (cookieName && cookieName in getCookieDatas) {
  				return getCookieDatas[cookieName];
  			} else {
  				return getCookieDatas;
  			}
  		} else {
  			return '';
  		}
  	},
  
  	/**
  	 * 設定
  	 * @param {string} cookieName 設定するCookieの名前
  	 * @param {string} value 設定する値
  	 * @param {string} domain 有効ドメイン
  	 * @param {string} path 有効パス
  	 * @param {string} expires 有効期限
  	 * @param {boolean} secure セキュアとするか
  	 * @return {boolean} 設定に成功した場合はtrue、失敗した場合はfalseを返す
  	 */
  	set : function(cookieName, value, domain, path, expires, secure) {
  		if (!navigator.cookieEnabled || !cookieName || !value) return false;
  
  		var date, dt, ts, ts_after;
  
  		var setCookieData = cookieName + '=' + encodeURIComponent(value) + ';';
  
  		if (domain) setCookieData += 'domain=' + domain + ';';
  
  		if (path) setCookieData += 'path=' + path + ';';
  
  		if (expires) {
        dt = new Date();
        ts = dt.getTime();
  
        // 1時間後
        ts_after = ts + (1000 * 60 * 60 * expires);
  
        date = new Date(ts_after);
  			setCookieData += 'expires=' + date.toGMTString() + ';';
  		}
  
  		if (secure && secure === true && location.protocol.match(/https/)) {
  			setCookieData += 'secure';
  		}
  
  		document.cookie = setCookieData;
  
  		return true;
  	},
  
  	/**
  	 * 削除
  	 * @param {string} cookieName 削除するCookieの名前
  	 * @return {boolean} 削除に成功した場合はtrue、失敗した場合はfalseを返す
  	 */
  	del : function(cookieName) {
  		if (!navigator.cookieEnabled || !cookieName) return false;
  
  		var getCookieDatas = this.get();
  
  		if (getCookieDatas[cookieName]) {
  			var setCookieData = cookieName + '=;',
  			    date          = new Date(0);
  
  			setCookieData += 'expires=' + date.toGMTString() + '';
  
  			document.cookie = setCookieData;
  
  			return true;
  		}
  
  		return false;
  	}
  };
    class Editor {
    constructor(el,opt){
      this.el = el;
      if($("." + this.el).length > 0){
        this.event();
      }
    }
    event(){
      //------- サイドナビ アンカー ---------
      let options = {
        threshold: [0],
        rootMargin: '-49.9%',
      }
      const observerEnter = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          const item = entry.target;
          if(entry.intersectionRatio > 0){
            $(`.js-sideNav [href="#${$(item).attr('id')}"]`).siblings().removeClass('is-active')
            $(`.js-sideNav [href="#${$(item).attr('id')}"]`).addClass('is-active')
          } else {
            $(`.js-sideNav [href="#${$(item).attr('id')}"]`).removeClass('is-active')
          }
        })
      }, options)
  
      const anchorEl = document.querySelectorAll('[id*="anchor"]')
      anchorEl.forEach((e)=>{
        observerEnter.observe(e)
      })
  
      
      $('[id*="anchor"]').each(function() {
        let text = $(this).find('.anchorTitle').text();
        let id = $(this).attr('id');
        if(text) {
          let newElement = $(`<a href="#${id}" class="c-transition"><hr class="c-transition">${text}</a>`);
          $('.js-sideNav').append(newElement);
        }
      })
  
      $(".js-sideNav a").click(function() {
        setTimeout(() => {
          $(this).siblings().removeClass('is-active')
          $(this).addClass('is-active')
        }, 600)
      })
  
  
      //------- 〆サイドナビ アンカー ---------
  
      //------- 画像のheught,widthをrem化 ---------
      $('.text-editor img').each(function(index, el) {
        let width = $(el).attr('width')
        // $(el).attr('width')
        $(el).css({'width': `${width * 0.1 + 'rem'}`, 'height': `auto`})
      })
      //------- 画像のheught,widthをrem化 〆 ---------
  
      //------- アコーディオン ---------
      $('.js-editor-accordion .inner').css({'display': 'none'})
  
      $('.js-editor-accordion .trigger').on('click', function() {
        $(this).find('.trigger-icon').toggleClass('is-active')
        $(this).next().slideToggle(Number($('html').data('transition')))
      })
      //------- アコーディオン 〆 ---------
  
      //------- タブ切り替え ---------
      if($(window).innerWidth() >= '769') {
  
        //------- PCの場合 ---------
        $('.js-tab .inner > div > div:nth-of-type(n + 2)').css({'display': 'none'})
        $('.js-tab .trigger .elementor-element:nth-of-type(1)').addClass('is-active')
    
        $('.js-tab .trigger .elementor-element').on('click', function() {
          $(this).siblings().removeClass('is-active')
          $(this).addClass('is-active')
          $(this).closest('.js-tab').find('.inner-child').css({'display': 'none'})
          $(this).closest('.js-tab').find('.inner-child').eq($(this).index()).fadeIn(Number($('html').data('transition')))
        })
        //------- PCの場合 〆 ---------
  
      } else {
  
        //------- SPの場合 ---------
        $('.js-tab').each(function() {
          const _el = $(this)
          const trigger_child = _el.find('.trigger-child')
          _el.find('.inner-child').each(function(index) {
            $(this).before(trigger_child[index])
          })
        })
  
        $('<span></span>').appendTo('.trigger-child > div')
  
        $('.inner-child').css({'display': 'none'})
        $('.trigger-child').click(function() {
          $(this).find('span').toggleClass('is-active')
          $(this).next().slideToggle(Number($('html').data('transition')))
        })
        //------- SPの場合 〆 ---------
        
      }
      //------- タブ切り替え 〆 ---------
    }
  }
    class FormConvert {
    constructor(el,opt){
      this.el = el;
      if($("." + this.el).length > 0){
        this.event();
      }
    }
    event(){
      //全角から半角
      function replaceZtoH(str){
        str = str.replace(/[！-～]/g, function(s){
          return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
        });
        str = str.replace(/[-－﹣−‐⁃‑‒–—﹘―⎯⏤ーｰ─━]/g, '-');
        return str;
      }
      const el = document.querySelector('.js-convert');
      el.addEventListener('blur', () => {
        const br = el.value;
        const ar = replaceZtoH(br);
        el.value = ar;
      });
    }
  }
  
    // ------------------------------------------
  // imgタグに「js-parallax」クラス、そのimgタグに要素をラップしてheightを指定すると、画像がはみ出た分が動く
  // 「data-scrub」属性に数字を入れると、動きの滑らかさが変わる
  // ------------------------------------------
  class ImgParallax {
    constructor(el,opt){
      this.el = el;
      if($("." + this.el).length > 0){
        this.event();
      }
    }
    event(){
      let cls = this.el;
      let para_ele = document.querySelectorAll("." + this.el);
      para_ele.forEach((ele, index)=> {
        let property,scrub;
  
        $(ele).css({
          'object-fit':'cover',
          'object-position':'50% 0%',
          'width':'100%',
          'height':'100%',
        })
  
        property = '50% 100%';
        scrub = $(ele).data('scrub') ? $(ele).data('scrub') : 3;
  
        ele.classList.add(cls + index);
        gsap.to('.' + cls + index, {
          objectPosition: property,
          scrollTrigger: {
            trigger: '.' + cls + index, // 要素がビューポートに入ったときにアニメーション開始
            start: 'top bottom',
            end: 'bottom top',
            scrub: scrub,
            merker: true,
          }
        })
      })
    }
  }
  
    class InviewEvent {
    constructor(el, opt){
      this.el = "." + el;
      this.all = this.el + '-all';
      this.eachUp = this.el + '-each';
      this.eachItem = this.el + '-eachItem';
      this.eachItemFast = this.el + '-eachItem-fast';
      this.eachItemDelay = this.el + '-eachItem-delay';
      if($(this.el).length > 0){
        this.event();
      }
    }
    event() {
      let options = {
        threshold: [0, 0.05, 0.1, 1]
      }
      let optionsAll = {
        threshold: [0, 0.9, 1]
      }
      const observerEnter = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          const item = entry.target;
          if(entry.intersectionRatio >= 0.05){
            item.classList.add('is-inview');
            if(item.classList.contains('js-inview-each')){
              this.inviewEachUp(item);
            }
            if(item.classList.contains('js-inview-lottie')){
              this.inviewLottie(item);
            }
            observerEnter.unobserve(item);
          }
        });
      }, options);
      const observerAll = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          const item = entry.target;
          if(entry.intersectionRatio >= 0.9){
            item.classList.add('is-inview');
            if(item.classList.contains('js-inview-each')){
              this.inviewEachUp(item);
            }
            observerAll.unobserve(item);
          } else {
            item.classList.remove('is-inview');
          }
        });
      }, optionsAll);
      const inviewItem = document.querySelectorAll(this.el);
      const inviewAllItem = document.querySelectorAll(this.all);
      inviewItem.forEach((e)=>{
        observerEnter.observe(e);
      });
      inviewAllItem.forEach((e)=>{
        observerAll.observe(e);
      });
    }
    inviewEachUp(item){
      $(item).find(this.eachItem).each((i,el)=>{
        gsap.to($(el), {
          // duration: 0.8,
          // alpha: 1,
          delay: (0.2 * i),
          // y: 0,
          // x: 0,
          onComplete: ()=>{
            $(el).addClass('is-inview');
          }
        });
      });
      $(item).find(this.eachItemFast).each((i,el)=>{
        gsap.to($(el), {
          // duration: 0.8,
          // alpha: 1,
          delay: (0.1 * i),
          // y: 0,
          // x: 0,
          onComplete: ()=>{
            $(el).addClass('is-inview');
          }
        });
      });
      $(item).find(this.eachItemDelay).each((i,el)=>{
        gsap.to($(el), {
          // duration: 0.8,
          // alpha: 1,
          delay: (0.5 * i),
          // y: 0,
          // x: 0,
          onComplete: ()=>{
            $(el).addClass('is-inview');
          }
        });
      });
    }
    inviewLottie(item){
      if($(item).hasClass('js-lottie-flow')) {
        lottie.flow();
      }
      if($(item).hasClass('js-lottie-no01')) {
        lottie.no01();
      }
      if($(item).hasClass('js-lottie-no02')) {
        lottie.no02();
      }
      if($(item).hasClass('js-lottie-no03')) {
        lottie.no03();
      }
      if($(item).hasClass('js-lottie-no04')) {
        lottie.no04();
      }
      if($(item).hasClass('js-lottie-no05')) {
        lottie.no05();
      }
      if($(item).hasClass('js-lottie-no06')) {
        lottie.no06();
      }
      if($(item).hasClass('js-lottie-no07')) {
        lottie.no07();
      }
    }
  }
  
    class Modal {
    constructor(el,opt){
      this.el = el;
      this.event();
      if($("." + this.el).length > 0){
        this.event();
      }
    }
    event(){
      $("." + this.el).on('click', function(e) {
        e.preventDefault();
        $(`[data-id='${$(this).attr('id')}']`).addClass('is-active');
        scrollBanOpen();
      })
  
      $("." + this.el + "-close").on('click', function() {
        $('.js-modal-container').removeClass('is-active');
        scrollBanClase();
      })
    }
  }
    // -------------------------------------------------
  // スクロール禁止
  // -------------------------------------------------
  let scrollTop = 0;
  
  function scrollBan() {
    const body = $('html')[0];
    // スクロール禁止
    if(body.classList.contains('is-hidden')){
      body.classList.remove('is-hidden');
      window.scrollTo(0, scrollTop);
      $('html').css({'scroll-behavior': 'smooth'})
    } else {
      scrollTop = window.scrollY;
      body.style.top = (scrollTop * -1) + 'px';
      body.classList.add('is-hidden');
      $('html').css({'scroll-behavior': 'inherit'})
    }
  }
    class TopElementor {
    constructor(el,opt){
      this.el = el;
      if($("." + this.el).length > 0){
        this.event();
      }
    }
    event(){
      $('.js-elementor-drawer-trigger').on('click', function(){
        $('html').toggleClass('is-elementor-drawer-open');
        scrollBan();
      });
  
      let scrollTimer;
      $(window).on('scroll', function() {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function() {
          if($(window).scrollTop() > 100) {
            $('html').addClass('is-scroll');
          } else {
            $('html').removeClass('is-scroll');
          }
        }, 100);
      });
  
    }
  }
  

  // ページ読み込みが完了したら100%に設定し、しばらく後にバーを消す
  window.addEventListener('load', () => {
    setTimeout(() => {
      $('.js-loading').fadeOut();
    }, 1500);
  });

  (() => {

    let imgParallax = new ImgParallax('js-parallax');
    let inviewEvent = new InviewEvent('js-inview');
    
    // ------------------------------
    // トップページ用
    // ------------------------------
    let top = new Top('p-top');
    
    // ------------------------------
    // ページビルダー用
    // ------------------------------
    let topElementor = new TopElementor('js-topElementor');
    let modal = new Modal('js-modal');
    let accordion = new Accordion('js-accordion');
    let editor = new Editor('c-content');

  })();

  //DOMContentLoaded
  $(() => {
  });

  //images resources loaded
  $(window).on('load', () => {

    $(window).trigger('loading');
  });

  //after loading animation
  $(window).on('loading', () => {
  });
})(jQuery);